import Modal from "@/common/components/Modal";
import { BillResumeData } from "../../types/bills.type";
import { DownloadIcon, FileIcon } from "lucide-react";
import Button from "@/common/components/Button";
import Box from "@/common/components/Box";

interface ReportsModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  bill?: BillResumeData;
}

const ReportsModal = ({ isOpen, setIsOpen, bill }: ReportsModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Relatórios da fatura"
      footer="Fechar"
      onConfirm={() => setIsOpen(false)}
      body={(
        <div className="max-h-[420px] overflow-y-auto">
          <Box className="flex flex-col gap-4 text-white-800">
            {bill?.reports?.map((report, index) => {
              return (
                <div key={`report-link-${index}`} className="bg-zinc-900 rounded-lg overflow-hidden flex gap-3">
                  <div className="rounded-lg p-3 bg-gray-800">
                    <FileIcon strokeWidth={1.5} size={28} />
                  </div>

                  <div className="w-full flex items-center justify-between">
                    <p className="break-all">{report.filename}</p>

                    <Button 
                      variant="link-white" 
                      onClick={() => window.open(report.url, '_blank')} 
                      className="p-3 ms-auto"
                    >
                      <DownloadIcon />
                    </Button>
                  </div>
                </div>
              );
            })}
          </Box>
        </div>
      )}
    />
  );
};

export default ReportsModal;